import { useEffect } from "react";
import { API_BASE } from "../api/client";

/*
 * Counts one view of a KIND of page — "home", "event", "match", "results" —
 * not of a URL. The Association asked how much each part of the portal is used;
 * counting every match page separately would answer with a list as long as the
 * season instead of a number.
 *
 * Nothing about the viewer is sent or stored. The request is fire-and-forget:
 * a counter that fails must never delay or break the page it is counting.
 */
export function usePageView(key: string) {
  useEffect(() => {
    if (!key) return;
    // React 18 mounts twice in development; this keeps the count honest.
    let done = false;
    const t = setTimeout(() => {
      if (done) return;
      done = true;
      fetch(`${API_BASE}/views/${encodeURIComponent(key)}`, { method: "POST" }).catch(() => {});
    }, 400);
    return () => clearTimeout(t);
  }, [key]);
}
